import type {
  DigitalWallet,
  PaymentSelection
} from '../../../services/purchase-payments-api.types';

export const isDigitalWalletSelection = (paymentSelection: PaymentSelection | undefined) =>
  paymentSelection?.selectionType === 'DigitalWallet';

export const isPayLaterSelection = (paymentSelection: PaymentSelection | undefined) =>
  paymentSelection?.selectionType === 'CashiersCheck' ||
  paymentSelection?.selectionType === 'WireTransfer';

export const getPayLaterLabel = (paymentSelection: PaymentSelection | undefined) => {
  switch (paymentSelection?.selectionType) {
    case 'CashiersCheck':
      return "Cashier's check";
    case 'WireTransfer':
      return 'Wire transfer';
    default:
      return undefined;
  }
};

export const getDigitalWalletLabel = (digitalWallet: DigitalWallet | undefined) => {
  switch (digitalWallet) {
    case 'ApplePay':
      return 'Apple Pay';
    case 'GooglePay':
      return 'Google Pay';
    default:
      return 'Apple Pay or Google Pay';
  }
};
